// extracted by mini-css-extract-plugin
export default {"panel":"MenuPanel_panel__1Ka-L","grid":"MenuPanel_grid__FTPX1","skeleton":"MenuPanel_skeleton__vWgEx"};